import abi from "./contract/GlobalPool.json";
import { useState, useEffect } from "react";
import { ethers } from "ethers";
import Buy from "./component/buy";
import Buy1 from "./component/buy1";
import Memos from "./component/memos";
import "./copy.png";
import Buy3 from "./component/buy3";



function App() {
  const [state, setState] = useState({
    provider: null,
    signer: null,
    contract: null,
  });
  
  const [account, setAccount] = useState("None");
  const[b,setB]=useState("None");
  const[direct,setDirect]=useState("None");
  const[directs,setDirects]=useState("None");
  const[level,setLevel]=useState("None");
  const[wlevel,setLevelw]=useState("None");
  const[level1,setLevel1]=useState("None");
  const[wlevel1,setLevelw1]=useState("None");
  const[plevel,setLevelp]=useState("None");
  const[pack,setpackage]=useState("None");
  const[pack3,setpackage3]=useState("None");
  const[pack1,setpackage1]=useState("None");
  const[refer,setrefer]=useState("None");
  const[refer4,setrefer4]=useState("None");
  const[refer3,setrefer3]=useState("None");
  const[refer1,setrefer1]=useState("None");
  const[refer2,setrefer2]=useState("None");
const [tasks,setTasks] = useState([]);
const [tasks1,setTasks1] = useState([]);
const [tt,settt]=useState("None");
const [tt4,settt4]=useState("None");
const[dd,setDD]=useState("None");
const[dd1,setDD1]=useState("None");
const[dd2,setDD2]=useState("None");
const[referlink,setreflink]=useState("None");
const[bonanza,setBonanza]=useState("None");
const[upd,setupd]=useState("None");
const[upd1,setupd1]=useState("None");
const[upd2,setupd2]=useState("None");
const[upd3,setupd3]=useState("None");
const [tt1,settt1]=useState("None");
const [roi,seroi]=useState("None");
const [roi1,seroi1]=useState("None");
const [roi2,seroi2]=useState("None");
const [a1,sea1]=useState("None");
const [a2,sea2]=useState("None");
const [a3,sea3]=useState("None");
const [tt2,settt2]=useState("None");
const [tt3,settt3]=useState("None");
const[b1,setb1]=useState("None");
const[b2,setb2]=useState("None");
const[b3,setb3]=useState("None");
const[b4,setb4]=useState("None");
const[b5,setb5]=useState("None");
const[b6,setb6]=useState("None");
const[b7,setb7]=useState("None");
const[b8,setb8]=useState("None");
const[b9,setb9]=useState("None");
const[b10,setb10]=useState("None");
const[b11,setb11]=useState("None");
const[b12,setb12]=useState("None");
const[b13,setb13]=useState("None");
const[b14,setb14]=useState("None");
const[b15,setb15]=useState("None");
const[b16,setb16]=useState("None");
const[reward,setreward]=useState("None");
const[reward1,setreward1]=useState("None");
const[reward2,setreward2]=useState("None");
const[reward3,setreward3]=useState("None");
const[reward4,setreward4]=useState("None");
const[reward5,setreward5]=useState("None");
const[reward6,setreward6]=useState("None");
const[reward7,setreward7]=useState("None");
const[reward8,setreward8]=useState("None");
const[reward9,setreward9]=useState("None");
const[reward10,setreward10]=useState("None");

const[x1,setx1]=useState("None");
const[x2,setx2]=useState("None");
const[x3,setx3]=useState("None");
const[x4,setx4]=useState("None");

  useEffect(() => {
    
    const connectWallet = async () => {
      
      const contractAddress = "0xa7c554fbe6348300ac8268f8b4f893e80490d745";
      const contractABI = abi.abi;
      const searchParams = new URLSearchParams(window.location.search);
    const myParam = searchParams.get('ref');
    console.log(myParam);
    document.querySelector("#name").value=myParam;
if(myParam == null)
  {
    document.querySelector("#name").value="0x24DA1ED67308215f5218d5934B9489ad108cA2e0";
  }
  
  try {
    const { ethereum } = window;
  //  document.querySelector("#test").value = "0";
    if (ethereum) {
      const account = await ethereum.request({
        method: "eth_requestAccounts",
       
      });
     
      window.ethereum.on("chainChanged", () => {
        window.location.reload();
      });

      window.ethereum.on("accountsChanged", () => {
        
        window.location.reload();
      });
          const provider = new ethers.providers.Web3Provider(ethereum);
        
          try {
            const selectedNetwork = await provider.getNetwork();
          
            if (selectedNetwork.chainId !== 56) {
              await window.ethereum.request({
                method: 'wallet_switchEthereumChain',
                params: [{ chainId: '0x38' }], // Binance Smart Chain Mainnet chainId is 97 in decimal, which is 0x61 in hex
              });
              console.log("You have switched to the Binance network");
            } else {
              console.log("You are already on the Binance network");
            }
          } catch (switchError) {
            // The network has not been added to MetaMask
            if (switchError.code === 4902) {
              console.log("Please add the Binance network to MetaMask");
            } else {
              console.log("Cannot switch to the network");
            }
          }
        
        
        
          const signer = provider.getSigner();
          const contract = new ethers.Contract(
            contractAddress,
            contractABI,
            signer
          );
          setAccount(account);
          setState({ provider, signer, contract });
          document.querySelector("#us").value  = account[0];
      let alltasks = await contract.getMemos(account[0]);
      setTasks(alltasks);
	  let alltasks1 = await contract.getMemos1(account[0]);
      setTasks1(alltasks1);

      var i = 0;
      const refer = (alltasks[1]);
      setrefer(refer);
      const a1 = Number(alltasks[0]);
      sea1(a1);
      const refer2 = (alltasks[23]);
     setrefer2(refer2);
	 const x4 = Number(alltasks[22])/1000000000000000000;
     setx4(x4);
      const b =Number(alltasks[2]);
     

     document.querySelector("#hid").value  = (alltasks[1]);
     const direct =Number(alltasks[2]);
     setDirect(direct);
     const level = Number(alltasks[4]);
     setLevel(level);


     const plevel = Number(alltasks[21])/1000000000000000000;
     setLevelp(plevel);
     
    
     const pack = Number(alltasks[3]) ;

setpackage(pack);

document.querySelector("#pp").value  = Number(alltasks[3]);




     setB(b);

     

     const dd = Number(alltasks[9]);
          
     setDD(dd);

     const reward1 = Number(alltasks[11])/1000000000000000000;
          
     setreward1(reward1);
     
     const reward2 = Number(alltasks[38])/1000000000000000000;
    
     setreward2(reward2);
     const reward3 = Number(alltasks[27])/1000000000000000000;
          
     setreward3(reward3);
	   
	 	
								
	
      const reward4 =  Number(alltasks[23])/1000000000000000000;
      setreward4(reward4);
      const reward5 =  Number(alltasks[28]);
      setreward5(reward5);




      const reward6 =  Number(alltasks[28]);
      setreward6(reward6);

      const reward7 =  Number(alltasks[29]);
      setreward7(reward7);


     const x1 = Number(alltasks[17])/1000000000000000000;
     setx1(x1);
     const x2 = Number(alltasks[18])/1000000000000000000;
     setx2(x2);
     const x3 = Number(alltasks[19])/1000000000000000000;
     setx3(x3);
     


     const dd2 = Number(alltasks[12]);
          
     setDD2(dd2);

     const dd1 =  Date.now() / 1000;
     setDD1(dd1);


     const tt1 = Math.trunc((dd1 - dd) / (3660 * 24 )) ;
   //  const tt1 =  (dd1.getTime() - dd.getTime())/ (1000 * 60 * 60 * 24);
     
     settt1(tt1);

     const tt2 = Math.trunc((dd1 - dd2) / (3600 * 24  )) ;
     //  const tt1 =  (dd1.getTime() - dd.getTime())/ (1000 * 60 * 60 * 24);
       
       settt2(tt2);
      
       document.querySelector("#tt2").value = tt2;
       
       const b1 = Number(alltasks[5]) ;
       setb1(b1);
       const b2 = Number(alltasks[6]) ;
       setb2(b2);
       const b3 = Number(alltasks[7]) ;
       setb3(b3);
       const b4 = Number(alltasks[8]) ;
       setb4(b4);
       const b5 = Number(alltasks[9]) ;
       setb5(b5);
       const b6 = Number(alltasks[10]) ;
       setb6(b6);
       const b7 = Number(alltasks[25]) ;
       setb7(b7);
     
	   const wlevel = Number(alltasks[25])/1000000000000000000 ;
          
 setLevelw(wlevel);
 const wlevel1 = Number(alltasks[15])/1000000000000000000;
          
 setLevelw1(wlevel1);
 const level1 = Number(alltasks[21]) ;
          
 setLevel1(level1);
 const a3 = Number(alltasks1[2])/1000000000000000000;
          
     sea3(a3);

    // document.querySelector("#wi1").value = roi2;
     
    // const a1 = Number(alltasks1[0])-1;
          
    // sea1(a1);
    // const a3 = Number(alltasks1[2])/1000000000000000000;
          
   //  sea3(a3);
     const a2 = Number(alltasks[24]);
    sea2(a2);   
     var rr = 0;
    // const tt4 =  Number(alltasks[15])/1000000000000000000;
    // settt4(tt4);
     
const pack1 = Number(alltasks[22])/1000000000000000000;
setpackage1(pack1);
     const tt =  Number(alltasks[16])/1000000000000000000;
     settt(tt);
     const tt3 = Number(alltasks[10])/1000000000000000000;
     settt3(tt3);
     document.querySelector("#bal").value = tt3;
     const referlink = 'https://metamint.info/?ref='+ account;
     setreflink(referlink);
     document.querySelector("#link").value =referlink;


     const upd1 = Number(alltasks[29])/1000000000000000000;
          
     setupd1(upd1);
	 const upd2 = Number(alltasks[30])/1000000000000000000;
          
     setupd2(upd2);
	 const upd3 = Number(alltasks[31])/1000000000000000000;
          
     setupd3(upd3);


console.log(pack);




 
        } else {
          alert("Please install metamask");
        }
      } catch (error) {
        console.log(error);
      }
    };
    
   
    
    connectWallet();
    
    function myFunction() {
      
      var copyText = "hello";
      copyText.select();
      copyText.setSelectionRange(0, 99999); // For mobile devices
      
    
      // Copy the text inside the text field
      navigator.clipboard.writeText(copyText.valueOf);
    }

  }, []);

 
  // console.log(state);
  return (
  <div>
    <input type="hidden" id ="link"></input>
    <input type="hidden" id ="hid"></input>
    <input type="hidden" id ="us"></input>
    <input type="hidden" id ="pp"></input>
    <input type="hidden" id ="tt2"></input>
    <input type="hidden" id ="wi1"></input>
    <input type="hidden" id ="roi"></input>
    <input type="hidden" id ="bal"></input>
   <div class="col-xlg-3 col-md-6 col-12 mb-30">
            <div class="top-report">
              <div class="head">
                <h4>Join</h4>
                <a href="#" class="view"></a>
              </div>
		 <div class="content">
              
                <h2> <input type="text" id ="amt" ></input> <br></br><br></br>
					  <Buy state={state}  /></h2>
              </div>
			 </div>
          </div>			

	<div class="col-xlg-3 col-md-6 col-12 mb-30">
            <div class="top-report">
              <div class="head">
                <h4>Withdraw</h4>
                <a href="#" class="view"></a>
              </div>
		 <div class="content">
                <h2> 
					<input type="text" id ="test" ></input><br></br><br></br>
						 <Buy3 state={state}  />
				</h2>
              </div>
			 </div>
          </div>	

		  <div class="col-xlg-3 col-md-6 col-12 mb-30">
            <div class="top-report">
              <div class="head">
                <h4>Trade</h4>
                <a href="#" class="view"></a>
              </div>
		 <div class="content">
                <h2> 
				 <Buy1 state={state}  />
				</h2>
              </div>
			 </div>
          </div>			

		  <div class="col-xlg-3 col-md-6 col-12 mb-30">
            <div class="top-report">
              <div class="head">
                <h4>Volume</h4>
                <a href="#" class="view"></a>
              </div>
		 <div class="content">
                <h2> 
				 {tt} USDT
				</h2>
              </div>
			 </div>
          </div>			

<div class="col-xlg-3 col-md-6 col-12 mb-30">
            <div class="top-report">
              <div class="head">
                <h4>My Investment</h4>
                <a href="#" class="view"></a>
              </div>
		 <div class="content">
                <h2> 
				 {pack} USDT
				</h2>
              </div>
			 </div>
          </div>

<div class="col-xlg-3 col-md-6 col-12 mb-30">
            <div class="top-report">
              <div class="head">
                <h4>Direct Team</h4>
                <a href="#" class="view"></a>
              </div>
		 <div class="content">
                <h2> 
				 {direct} 
				</h2>
              </div>
			 </div>
          </div>
					
            <div class="col-xlg-3 col-md-6 col-12 mb-30">
            <div class="top-report">
              <div class="head">
                <h4>Level Team</h4>
                <a href="#" class="view"></a>
              </div>
		 <div class="content">
                <h2> 
				 {level} 
				</h2>
              </div>
			 </div>
          </div>

		       <div class="col-xlg-3 col-md-6 col-12 mb-30">
            <div class="top-report">
              <div class="head">
                <h4>Team Business</h4>
                <a href="#" class="view"></a>
              </div>
		 <div class="content">
                <h2> 
				 {level1} USDT 
				</h2>
              </div>
			 </div>
          </div>

		    <div class="col-xlg-3 col-md-6 col-12 mb-30">
            <div class="top-report">
              <div class="head">
                <h4>Level Bonus</h4>
                <a href="#" class="view"></a>
              </div>
		 <div class="content">
                <h2> 
				 {x3} USDT 
				</h2>
              </div>
			 </div>
          </div>

<div class="col-xlg-3 col-md-6 col-12 mb-30">
            <div class="top-report">
              <div class="head">
                <h4>Trading Bonus</h4>
                <a href="#" class="view"></a>
              </div>
		 <div class="content">
                <h2> 
				 {x1} USDT 
				</h2>
              </div>
			 </div>
          </div>

		  <div class="col-xlg-3 col-md-6 col-12 mb-30">
            <div class="top-report">
              <div class="head">
                <h4>Total Bonus</h4>
                <a href="#" class="view"></a>
              </div>
		 <div class="content">
                <h2> 
				 {x1+x3+upd1+upd2+upd3+reward1+reward2+reward3} USDT 
				</h2>
              </div>
			 </div>
          </div>

		  <div class="col-xlg-3 col-md-6 col-12 mb-30">
            <div class="top-report">
              <div class="head">
                <h4>Comunity Bonus</h4>
                <a href="#" class="view"></a>
              </div>
		 <div class="content">
                <h2> 
				 {reward1} USDT 
				</h2>
              </div>
			 </div>
          </div>

		  <div class="col-xlg-3 col-md-6 col-12 mb-30">
            <div class="top-report">
              <div class="head">
                <h4>Current Week Earnings</h4>
                <a href="#" class="view"></a>
              </div>
		 <div class="content">
                <h2> 
				 {reward4} USDT 
				</h2>
              </div>
			 </div>
          </div>

		  <div class="col-xlg-3 col-md-6 col-12 mb-30">
            <div class="top-report">
              <div class="head">
                <h4>Silver Direct Royalty Bonus</h4>
                <a href="#" class="view"></a>
              </div>
		 <div class="content">
                <h2> 
				 {reward2} USDT 
				</h2>
              </div>
			 </div>
          </div>

	  <div class="col-xlg-3 col-md-6 col-12 mb-30">
            <div class="top-report">
              <div class="head">
                <h4>Gold Direct Royalty Bonus</h4>
                <a href="#" class="view"></a>
              </div>
		 <div class="content">
                <h2> 
				 {reward3} USDT 
				</h2>
              </div>
			 </div>
          </div>
         <div class="col-xlg-3 col-md-6 col-12 mb-30">
            <div class="top-report">
              <div class="head">
                <h4>Galaxy Club</h4>
                <a href="#" class="view"></a>
              </div>
		 <div class="content">
                <h2> 
				 {reward5} USDT 
				</h2>
              </div>
			 </div>
          </div>
		  <div class="col-xlg-3 col-md-6 col-12 mb-30">
            <div class="top-report">
              <div class="head">
                <h4>TOTAL WITHDRAWL</h4>
                <a href="#" class="view"></a>
              </div>
		 <div class="content">
                <h2> 
				 {wlevel1} USDT 
				</h2>
              </div>
			 </div>
          </div>

		  <div class="col-xlg-3 col-md-6 col-12 mb-30">
            <div class="top-report">
              <div class="head">
                <h4>Level 1 Business</h4>
                <a href="#" class="view"></a>
              </div>
		 <div class="content">
                <h2> 
				 {b1} USDT 
				</h2>
              </div>
			 </div>
          </div>
			
			<div class="col-xlg-3 col-md-6 col-12 mb-30">
            <div class="top-report">
              <div class="head">
                <h4>Level 2 Business</h4>
                <a href="#" class="view"></a>
              </div>
		 <div class="content">
                <h2> 
				 {b2} USDT 
				</h2>
              </div>
			 </div>
          </div>
            
			<div class="col-xlg-3 col-md-6 col-12 mb-30">
            <div class="top-report">
              <div class="head">
                <h4>Level 3 Business</h4>
                <a href="#" class="view"></a>
              </div>
		 <div class="content">
                <h2> 
				 {b3} USDT 
				</h2>
              </div>
			 </div>
          </div>

		  <div class="col-xlg-3 col-md-6 col-12 mb-30">
            <div class="top-report">
              <div class="head">
                <h4>Level 4 Business</h4>
                <a href="#" class="view"></a>
              </div>
		 <div class="content">
                <h2> 
				 {b4} USDT 
				</h2>
              </div>
			 </div>
          </div>

		  <div class="col-xlg-3 col-md-6 col-12 mb-30">
            <div class="top-report">
              <div class="head">
                <h4>Level 5 Business</h4>
                <a href="#" class="view"></a>
              </div>
		 <div class="content">
                <h2> 
				 {b5} USDT 
				</h2>
              </div>
			 </div>
          </div>

		  <div class="col-xlg-3 col-md-6 col-12 mb-30">
            <div class="top-report">
              <div class="head">
                <h4>Level 6 Business</h4>
                <a href="#" class="view"></a>
              </div>
		 <div class="content">
                <h2> 
				 {b6} USDT 
				</h2>
              </div>
			 </div>
          </div>

		  <div class="col-xlg-3 col-md-6 col-12 mb-30">
            <div class="top-report">
              <div class="head">
                <h4>Level 7 Business</h4>
                <a href="#" class="view"></a>
              </div>
		 <div class="content">
                <h2> 
				 {b7} USDT 
				</h2>
              </div>
			 </div>
          </div>

		  <div class="col-xlg-3 col-md-6 col-12 mb-30">
            <div class="top-report">
              <div class="head">
                <h4>Level 8 Business</h4>
                <a href="#" class="view"></a>
              </div>
		 <div class="content">
                <h2> 
				 {b8} USDT 
				</h2>
              </div>
			 </div>
          </div>

		  <div class="col-xlg-3 col-md-6 col-12 mb-30">
            <div class="top-report">
              <div class="head">
                <h4>Level 9 Business</h4>
                <a href="#" class="view"></a>
              </div>
		 <div class="content">
                <h2> 
				 {b9} USDT 
				</h2>
              </div>
			 </div>
          </div>

		  <div class="col-xlg-3 col-md-6 col-12 mb-30">
            <div class="top-report">
              <div class="head">
                <h4>Level 10 Business</h4>
                <a href="#" class="view"></a>
              </div>
		 <div class="content">
                <h2> 
				 {b10} USDT 
				</h2>
              </div>
			 </div>
          </div>

		  <div class="col-xlg-3 col-md-6 col-12 mb-30">
            <div class="top-report">
              <div class="head">
                <h4>Level 11 Business</h4>
                <a href="#" class="view"></a>
              </div>
		 <div class="content">
                <h2> 
				 {b11} USDT 
				</h2>
              </div>
			 </div>
          </div>

		  <div class="col-xlg-3 col-md-6 col-12 mb-30">
            <div class="top-report">
              <div class="head">
                <h4>My Account</h4>
                <a href="#" class="view"></a>
              </div>
		 <div class="content">
                <h2> 
				 {account} 
				</h2>
              </div>
			 </div>
          </div>

		  <div class="col-xlg-3 col-md-6 col-12 mb-30">
            <div class="top-report">
              <div class="head">
                <h4>My Referlink</h4>
                <a href="#" class="view"></a>
              </div>
		 <div class="content">
                <h2> 
				{referlink} <a href="#">
       <button><img src ="copy.png" width={"15px"} onClick={() => {
         navigator.clipboard.writeText(referlink);}} /></button> </a>
				</h2>
              </div>
			 </div>
          </div>

		  <div class="col-xlg-3 col-md-6 col-12 mb-30">
            <div class="top-report">
              <div class="head">
                <h4>My Refer</h4>
                <a href="#" class="view"></a>
              </div>
		 <div class="content">
                <h2> 
				 {refer} 
				</h2>
              </div>
			 </div>
          </div>
            
		

					






   </div>

  );
}

export default App;